/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021-2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AeroModule } from '../../aero/aero.module';
import { BulbCommonModule } from '../../common/bulb-common.module';
import { ImageComponent } from './image.component';
import { ImageFadeDirective } from './image-fade.directive';
import { ResizeObserverDirective } from './resize-observer.directive';

/**
 * Bulb Image module.
 */
@NgModule({
  declarations: [
    ImageComponent,
    ImageFadeDirective,
    ResizeObserverDirective,
  ],
  imports: [
    AeroModule,
    BulbCommonModule,
    CommonModule,
  ],
  exports: [
    ImageComponent,
  ],
})
export class BulbImageModule { }
